<template>
    <div class="col-xl-5 col-lg-5">
        <div class="card transaction-history">
            <div class="card-header pb-0">
                <h3> Transaction</h3>
            </div>
            <div class="card-body theme-scrollbar">
                <table class="table table-bordernone table-responsive">
                    <thead>
                        <tr>
                            <th>Item Name</th>
                            <th>Date and Time</th>
                            <th>Income</th>
                            <th>Progress</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in table" :key="index">
                            <td>
                                <div class="d-flex">
                                    <div class="icon"><img class="img-fluid" :src="getImageUrl(item.img)" alt=""></div>
                                    <div class="flex-grow-1"><router-link to="/ecommerce/product/page/1">
                                            <h5>{{ item.name }}</h5>
                                        </router-link>
                                        <p>{{ item.delivery }}</p>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <h5>{{ item.date }}</h5>
                                <p>{{ item.day }}</p>
                            </td>
                            <td>
                                <h5>{{ item.income }}</h5>
                            </td>
                            <td>
                                <div class="progress-showcase">
                                    <p>{{ item.width }}</p>
                                    <div class="progress " :class="item.class" style="height: 5px;">
                                        <div class="progress-bar" role="progressbar" :style="{ 'width': item.width }"
                                            aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <h5>{{ item.status }}</h5>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="code-box-copy">
                    <button class="code-box-copy__btn btn-clipboard" data-clipboard-target="#transaction-view" title=""
                        data-bs-original-title="Copy" aria-label="Copy"><i class="icofont icofont-copy-alt"></i></button>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import tables from "@/data/tables"
import getImage from "@/mixins/getImage"
export default {
    mixins: [getImage],
    name: 'transactionPage',
    data() {
        return {
            table: tables.data
        }
    }
}
</script>